import clsx from "clsx";
import styled from "styled-components";

export const StyledFieldSet = styled.div.attrs(({ error }) => ({
  className: `form-control w-full h-full relative`,
}))``;

export const Label = styled.label.attrs(() => ({
  className: "label absolute p-0 text-tertiary z-10",
}))``;

export const Span = styled.span.attrs(({ disabled, className }) => ({
  className: `label-text text-primary bg-transparent pl-2 pt-[0.375rem] !text-xs !font-normal !leading-[0.875rem] ${className} ${clsx(
    {
      "bg-transparent": disabled,
    }
  )}`,
  "data-theme": "main",
}))``;
